import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=123330d3&"
import script from "./switch.vue?vue&type=script&lang=ts&"
export * from "./switch.vue?vue&type=script&lang=ts&"
import style0 from "./switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports